/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { RichTextSectionFragment } from "@cosmos/hygraph-schema";

import { BackgroundContainer, ResponsiveContainer, SectionContainer, CosmosRichText } from "@components/elements";
import { closeRichTextHeadingGaps } from "@components/elements/atoms/text/text.utils";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";

import { richTextContentStyles } from "./rich-text.section.styles";
import { RichTextButtons, RichTextHeading, RichTextStack } from "./rich-text.section.common";

export const RichTextSection = ({
	config,
	content,
	wide = false,
	centered = false,
	centeredButton = false,
	buttons = [],
}: RichTextSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(content?.html || buttons?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)} className="rich-text-section">
					<RichTextStack wide={wide} centered={centered || false}>
						{validHeading ? <RichTextHeading heading={config?.heading} centered={centered || false} /> : null}
						{validContent ? (
							<>
								<div className={richTextContentStyles}>
									{/* Close authored h1→h3 skips (aria-level only, tags/visuals unchanged). */}
									<CosmosRichText html={closeRichTextHeadingGaps(content?.html)} />
								</div>
								<RichTextButtons buttons={buttons} centeredButton={centeredButton} component="RichTextSection" />
							</>
						) : null}
					</RichTextStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
